import { render, staticRenderFns } from "./DtcItemModal.vue?vue&type=template&id=fb4edf5a&"
import script from "./DtcItemModal.vue?vue&type=script&lang=js&"
export * from "./DtcItemModal.vue?vue&type=script&lang=js&"
import style0 from "./DtcItemModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports